import { useTellescopeQuery } from "@tellescope/tanstack-query";
import { CheckCircle } from "lucide-react";

export interface CarePlanFormItemProps {
  id: string;
}

export const CarePlanFormItem = ({ id }: CarePlanFormItemProps) => {
  const formQuery = useTellescopeQuery({
    model: "forms",
    method: "getOne",
    request: id,
    enabled: !!id,
  });

  const form = formQuery.data;
  if (!form) return null;

  return (
    <>
      <CheckCircle size={12} />
      <p className="text-sm">{formQuery.data?.title}</p>
    </>
  );
};
